import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  getApiBaseUrl,
  ADD_ACTIVITY,
  LOGIN,
  GET_LOCATIONS,
} from "../../../Config/Config";
import { Select } from "antd";

const FilterTreeEditArea = ({
  onClose,
  blockName,
  blockId,
  areaName,
  areaId,
  areaData,
  onSuccess,
}) => {
  const [blocks, setBlocks] = useState([]);

  const [areas, setAreas] = useState([]);

  const [selectedBlockId, setSelectedBlockId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  const [loadingBlocks, setLoadingBlocks] = useState(false);
  const [loadingAreas, setLoadingAreas] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
  console.log(loading, "loading");
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  console.log(error, "error");

  const fetchBlocks = async () => {
    setLoadingBlocks(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      const data = await res.json();
      setBlocks(data?.ResultData || []);
    } catch (err) {
      console.error("Block fetch error", err);
    } finally {
      setLoadingBlocks(false);
    }
  };

  const fetchAreas = async (blockId) => {
    if (!blockId) return;

    setLoadingAreas(true);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Areas/getblockareas?BlockId=${blockId}`,
      );
      const data = await res.json();
      setAreas(data?.ResultData || []);
    } catch (err) {
      console.error("Area fetch error", err);
    } finally {
      setLoadingAreas(false);
    }
  };

  const handleSave = async () => {
    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "addAHU",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    const payload = {
      //   ID: areaData.ID,
      //   Code: ahuId,
      //   UpdatedBy: user?.UserID,
      //   BlockId: selectedBlockId,
      //   AreaId: selectedAreaId,
      //   ProcessType: ahuType,
      //   ScheduleDate: lastCleaningDate,
      //   FreqAllowanceDays: Number(freqAllowanceDays),
      //   cleaningDays: Number(cleaningDays),
    };

    try {
      setLoading(true);

      const response = await fetch(`${getApiBaseUrl()}/ahuph2/updateahu`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok && result?.status !== false) {
        await logActivity(
          true,
          `Area "${areaId}" Updated successfully for Block "${blockName}", Area "${areaName}"`,
        );

        Swal.fire("Success", "AHU Edited successfully!", "success").then(() => {
          onSuccess(); // 🔥 reload ONLY areas
          onClose(); // close modal
        });
      } else {
        await logActivity(
          false,
          `Failed to add AHU "${areaId}" for Block "${blockName}", Area "${areaName}"`,
        );

        Swal.fire("Failed", result?.message || "Unable to add AHU", "error");
      }
    } catch (error) {
      console.error("Network error:", error);

      await logActivity(
        false,
        `Error while adding AHU "${areaId}": ${error.message}`,
      );

      Swal.fire("Error", "Unable to connect to server.", "error");
    } finally {
      setLoading(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !areaId
      //   !ahuType ||
      //   !lastCleaningDate ||
      //   !freqAllowanceDays ||
      //   !cleaningDays
    ) {
      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning",
      );
      return;
    }

    setAskPassword(true);
  };
  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSave();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    if (areaData) {
      console.log("Editing AHU:", areaData);
    }
  }, [areaData]);

  useEffect(() => {
    fetchBlocks();
  }, []);

  useEffect(() => {
    if (blocks.length && blockId) {
      setSelectedBlockId(blockId);
    }
  }, [blocks, blockId]);

  useEffect(() => {
    if (!selectedBlockId) return;

    fetchAreas(selectedBlockId);
  }, [selectedBlockId]);

  useEffect(() => {
    if (areas.length && areaId) {
      setSelectedAreaId(areaId);
    }
  }, [areas, areaId]);

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Area</h5>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  fontWeight: "bold",
                  lineHeight: "1",
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                {/* Block (Disabled) */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Block</label>
                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Block"
                    value={selectedBlockId}
                    loading={loadingBlocks}
                    onChange={(value) => {
                      setSelectedBlockId(value);
                      setSelectedAreaId(null); // ✅ reset ONLY on user action
                      setAreas([]);
                    }}
                    options={blocks.map((b) => ({
                      value: b.BlockId,
                      label: b.BlockName,
                    }))}
                  />
                </div>

                {/* Area */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Area Name</label>

                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Area"
                    value={selectedAreaId}
                    loading={loadingAreas}
                    disabled={!selectedBlockId}
                    onChange={(value) => setSelectedAreaId(value)}
                    options={areas.map((a) => ({
                      value: a.Areaid,
                      label: a.AreaName,
                    }))}
                  />
                </div>
              </div>

              {askPassword && (
                <div className="mt-2">
                  <div className="mb-3 w-lg-75 m-auto">
                    <label className="form-label">
                      Confirm Password <span className="text-danger"> *</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setError("");
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        placeholder="Enter Password"
                      />
                      <span
                        className={`ti toggle-password ${
                          showPassword ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={handleAuth}
                    disabled={authLoading || !password}
                  >
                    {authLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                      setError("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            {!askPassword && (
              <div className="modal-footer gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />
    </>
  );
};

FilterTreeEditArea.propTypes = {
  onClose: PropTypes.func.isRequired,
  blockName: PropTypes.string,
  blockId: PropTypes.number,
  areaName: PropTypes.string,
  areaId: PropTypes.number,
  onSuccess: PropTypes.string,

  areaData: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    BlockId: PropTypes.number,
    AreaId: PropTypes.number,
    BlockName: PropTypes.string,
    areaName: PropTypes.string,
  }).isRequired,
};

export default FilterTreeEditArea;
